import { useTranslations } from 'utils';
import './Fee.scss';

type FeeProps = {
  value: number;
};

export function Fee({ value }: FeeProps) {
  const i18n = useTranslations();
  return (
    <div className="Offer-fee" data-testid="offer-fee">
      {i18n.t('offers.includes_fee', { fee: value.toString() })}
    </div>
  );
}
